const StatBox = ({ number, label }) => {
  return (
    <div className="stat-big">
      <div className="number">{number}</div>
      <div className="label">{label}</div>
    </div>
  );
};

export default StatBox;